import React from "react";
import { Button, Steps } from "rsuite";
import { useEffect, useState } from "react";
import { isValid } from "cpf-utils";
import axios from "axios";
import logo from "../../assets/logo.png";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { useDispatch, useSelector } from "react-redux";
import { Formik, form } from "formik";
import * as yup from "yup";
import {
 
  updateCliente,
  filterClientes,
  addClientes,
  addClientesStepTwo,
  stepCodeInsert,
} from "../../store/modules/cliente/actions";
import { Link } from "react-router-dom";

export default function Cadastro() {
  const dispatch = useDispatch();
  const {
    clientes,
    behavior,
    form,
    components,
    cliente,
    step1,
    step2,
    code,
    codeOk,
    steps
  } = useSelector((state) => state.cliente);

  const setComponent = (component, state) => {
    dispatch(
      updateCliente({
        components: { ...components, [component]: state },
      })
    );
  };

  const cadastroStepOne = async () => {
    if (!(await validateStep1())) return;
    dispatch(addClientes());
  };
  const cadastroStepTwo = async() => {
    if (!(await validateStep2())) return;
    dispatch(addClientesStepTwo());
  };

  const codeFormEqual = async  () => {
     
   //if (!(await codeInsert())) return;
    dispatch(stepCodeInsert());
  };

  const setStep1 = (key, value) => {
    
    dispatch(
      updateCliente({
        step1: { ...step1, [key]: value },
      })
    );
  };
  const setStep2 = (key, value) => {
    dispatch(
      updateCliente({
        step2: { ...step2, [key]: value },
      })
    );
  };
  const setCode = (key, value) => {
    dispatch(
      updateCliente({
        form: { [key]: value },
      })
    );
  };



  async function validateStep1() {
    if (steps.id === 1) {
      let schema = yup.object().shape({
        name: yup
          .string("Erro: Necessário preencher o campo Nome")
          .required("Erro: Necessário preencher o campo Nome"),
        email: yup
          .string("Erro: Necessário preencher o campo email")
          .email("Erro: Necessário preencher o campo email").required(),
        phone_number: yup
          .string("Erro: Necessário preencher o campo telefone")
          .required("Erro: Necessário preencher o campo telefone"),
      });



      try {
        await schema.validate(step1);
        return true;
      } catch (error) {
        dispatch(
          updateCliente({
            form: { ...form, type: "error", messageError: error.errors },
            steps: { ...steps, id: 1},
          })
        );
        return false;
      }
    }
  }

  async function validateStep2() {
    console.log("fora de valida step2")
    if (steps.id === 2 && codeOk.id == true) {
      console.log("dentro de valida step2")
      let schema = yup.object().shape({
        cpf:yup.string("Erro: Necessário preencher o campo cpf").required("Erro: Necessário preencher o campo cpf"),
    address: yup.string("Erro: Necessário preencher o campo endereço").required("Erro: Necessário preencher o campo endereço"),
    address_number: yup.number("Erro: falta numero de endereço").required("Erro: falta numero de endereço"),
    address_complement: yup.string(),
    address_district:yup.string("Erro: Necessário preencher o campo distrito").required("Erro: Necessário preencher o campo distrito"),
    address_city: yup.string("Erro: Necessário preencher o campo ciudad").required("Erro: Necessário preencher o campo ciudade"),
    address_state:yup.string("Erro: Necessário preencher o campo estado").required("Erro: Necessário preencher o campo estado"),
    address_zipcode:yup.number("Erro: Necessário preencher o campo Cep").required("Erro: Necessário preencher o campo Cep"),
    password:yup.string().required()
      });

      

      try {
        await schema.validate(step2);
        return true;
      } catch (error) {
        dispatch(
          updateCliente({
            form: { ...form, type: "error", messageError: error.errors },
          })
        );
        return false;
      }
    }
  }
  async function codeInsert() {
    console.log("codeInsert fora"+ steps.id + step2.id )
    if (steps.id === 2 && !codeOk.id) {
      console.log("codeInsert dentro")
      let schema = yup.object().shape({
        code: yup.string()
      });

      
     
      try {
        await schema.validate(form.decode);
        return true;
      } catch (error) {
        dispatch(
          updateCliente({
            form: { ...form, type: "error", messageError: error.errors },
          })
        );
        return false;
      }
    }
  }

/*useEffect(() => {
  try {
   
    if(step2.address_zipcode.length ==8){

      function CepInsert (){
        axios(
          {
            method:"get",
          url:`https://viacep.com.br/ws/${step2.address_zipcode}/json/`,
        
          }
          )
        .then(function (response) {
      
          dispatch(
            updateCliente({
              step2: { ...step2,
                address: response.data.logradouro,
                address_state:  response.data.uf,
                address_city: response.data.localidade,
                address_district:response.data.bairro
                
                
                },
            })
          );
        });
       
          }
          CepInsert()
    }
  
} catch (error) {

}


},[step2.address_zipcode] )
*/


  return (
    <div className="d-flex flex-column bd-highlight mb-3 justify-content-center  bg-dark align-items-center card ">
      <b className="  text-white"> Cadastro de usuario step {steps.id}</b>
      {steps.id === 1 && !code.id ? (
        <div className="d-flex flex-column bd-highlight mb-3  col-6 col-sm-6  col-md-8 col-lg-9 col-xl-9 justify-content-center  bg-dark align-items-center ">
          {form.type === "success" ? (
            <div className="alert alert-success" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          {form.type === "error" ? (
            <div className="alert alert-danger" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          <div className="form-group col-12 col-sm-12  col-md-9 col-lg-9 col-xl-8  text-white">
            <b className="">Nome</b>
            <input
              name="name"
              type="text"
              className="form-control"
              placeholder="Nome do cliente"
              value={step1.name}
              onChange={(e) => {
                setStep1("name", e.target.value);
              }}
            />
          </div>
          <div className="form-group col-12 col-sm-12  col-md-9 col-lg-9 col-xl-8  text-white">
            <b className="">email</b>
            <input
              name="email"
              type="email"
              className="form-control email  "
              placeholder="email do cliente"
              value={step1.email}
              onChange={(e) => {
                setStep1("email", e.target.value);
              }}
            />
            {!step1.email.includes("@") && step1.email.length > 2 && (
              <span className=" ">"email precisa de @"</span>
            )}
          </div>

          <div className="form-group col-12 col-sm-12  col-md-9 col-lg-9 col-xl-8 text-white">
            <b className="">Telefone</b>
            <input
              name="phone_number"
              type="text"
              className="form-control"
              placeholder="Telefone do cliente"
              value={step1.phone_number}
              onChange={(e) => {
                setStep1("phone_number", e.target.value);
              }}
            />

            {step1.phone_number.includes("-") &&
              step1.phone_number.length > 1 && (
                <span className=" ">Não use - </span>
              )}
            {step1.phone_number.includes("*") &&
              step1.phone_number.length > 1 && (
                <span className=" ">Não use * </span>
              )}
            {step1.phone_number.includes("/") &&
              step1.phone_number.length > 1 && (
                <span className=" ">Não use / </span>
              )}
            {step1.phone_number.includes(" ") &&
              step1.phone_number.length > 2 && (
                <span className=" ">Não use espacios</span>
              )}
            {isNaN(step1.phone_number) && step1.phone_number.length > 1 && (
              <span className=" ">Não use letras</span>
            )}
          </div>
        </div>
      ) : codeOk.id ? (
        <div className="d-flex flex-flex flex-wrap bd-highlight mb-3 justify-content-center  bg-dark align-items-center ">
             {form.type === "success" ? (
            <div className="alert alert-success" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          {form.type === "error" ? (
            <div className="alert alert-danger" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          <div className="form-group col-8 text-white">
            <b className="">CPF</b>
            <input
            name="cpf"
              type="text"
              className="form-control"
              placeholder="CPF do cliente"
              value={step2.cpf}
              onChange={(e) => {
                setStep2("cpf", e.target.value);
              }}
            />
            {step2.cpf.includes("-") && step2.cpf.length > 1 && (
              <span className=" ">Não use - </span>
            )}
            {step2.cpf.includes("*") && step2.cpf.length > 1 && (
              <span className=" ">Não use * </span>
            )}
            {step2.cpf.includes("/") && step2.cpf.length > 1 && (
              <span className=" ">Não use / </span>
            )}
            {step2.cpf.includes(" ") && step2.cpf.length > 2 && (
              <span className=" ">Não use espacios</span>
            )}

            {!isValid(step2.cpf) && <span className=" ">CPF não valido</span>}
          </div>

          <div className="form-group col-8  text-white">
            <b className="">Endereço</b>
            <input
            name="address"
              type="text"
              className="form-control "
              placeholder="Endereço do cliente"
              value={step2.address}
              onChange={(e) => {
                setStep2("address", e.target.value);
              }}
            />
          </div>

          <div className="form-group col-8  text-white">
            <b className="">Numero de endereço</b>
            <input
            name="address_number"
              type="text"
              className="form-control"
              placeholder="Numero de endereço"
              value={step2.address_number}
              onChange={(e) => {
                setStep2("address_number", e.target.value);
              }}
            />
          </div>

          <div className="form-group col-8  text-white">
            <b className="">Complemento</b>
            <input
            name="address_complement"
              type="text"
              className="form-control"
              placeholder="Complemento"
              value={step2.address_complement}
              onChange={(e) => {
                setStep2("address_complement", e.target.value);
              }}
            />
          </div>
          <div className="form-group col-8  text-white">
            <b className="">Distrito</b>
            <input
            name="address_district"
              type="text"
              className="form-control"
              placeholder="Distrito"
              value={step2.address_district}
              onChange={(e) => {
                setStep2("address_district", e.target.value);
              }}
            />
          </div>
          <div className="form-group col-8  text-white">
            <b className="">Ciudade</b>
            <input
            name="address_city"
              type="text"
              className="form-control  col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6"
              placeholder="Ciudade"
              value={step2.address_city}
              onChange={(e) => {
                setStep2("address_city", e.target.value);
              }}
            />
          </div>
          <div className="form-group col-8  text-white">
            <b className="">Estado</b>
            <input
            name="address_state"
              type="text"
              className="form-control  col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6"
              placeholder="Estado"
              value={step2.address_state}
              onChange={(e) => {
                setStep2("address_state", e.target.value);
              }}
            />
          </div>
          <div className="form-group col-8  text-white">
            <b className="">Cep</b>
            <input
            name="address_zipcode"
              type="text"
              className="form-control  col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6"
              placeholder="Cep"
              value={step2.address_zipcode}
              onChange={(e) => {
                setStep2("address_zipcode", e.target.value);
              }}
            />
          </div>

          <div className="form-group col-8  text-white ">
            <b className="">Password</b>
            <input
            name="password"
              type="password"
              className="form-control  col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6"
              placeholder="Digite seu password"
              value={base64_decode(step2.password)}
              onChange={(e) => {
                setStep2("password", base64_encode(e.target.value));
              }}
            />
          </div>
        </div>
      ) : (
        <div className="d-flex flex-flex flex-wrap bd-highlight mb-3 justify-content-center  bg-dark align-items-center">
          {form.type === "success" ? (
            <div className="alert alert-success" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          {form.type === "error" ? (
            <div className="alert alert-danger" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          <b className="">Digite o codigo enviado no email</b>
          <input
          name="code"
            type="text"
            className="form-control"
            placeholder="Digite seu codigo"
            value={base64_decode(form.decode)}
            onChange={(e) => {
              setCode("decode", base64_encode(e.target.value));
            }}
          />
        </div>
      )}

      {form.fail === true ? (
        <div class="p-3 mb-2 bg-danger text-white">`${form.errorTag}`</div>
      ) : (
        <div></div>
      )}

      <div className="form-group  d-flex flex-column wrap col-12 col-sm-12 col-xl-12 mb-1 justify-content-center align-items-center">
        {code.id.trim().length === 0 &&
        steps.id === 1 &&
        codeOk.id === false ? (
          <Button
            appearance="primary"
            color="green"
            loading={form.filtering}
            className="form-group col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6 mb-1 "
            onClick={()=>cadastroStepOne()} >
            Cadastrar
          </Button>
        ) : code.id.trim().length !== 0 && codeOk.id === false ? (
          <Button
            appearance="primary"
            color="green"
            loading={form.filtering}
            className="form-group col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6 mb-1 "
            onClick={() => 
              codeFormEqual()
            }
          >
            
            Continuar
          </Button>
        ) : (
          <Button
            appearance="primary"
            color="green"
            
            className="form-group col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6 mb-1 "
            onClick={() => 
              cadastroStepTwo()
            }
          >
            <Link className="form-group  text-white" to="/">
              Finalizar
            </Link>
          </Button>
        )}
        <Button
          appearance="primary"
          color="cyan"
          className="form-group  col-6 col-sm-6  col-md-6 col-lg-6 col-xl-6 mb-1 "
        >
          <Link to="/" className="text-white">
            Voltar
          </Link>
        </Button>
      </div>
    </div>
  );
}
